import ajax from "helpers/ajax";

export enum SendBlacklistPostalTypeEnum {
    Email = "email",
    Id = "id",
}

class BlacklistAction {
    static fetchSendBlacklistPostal = (identifier: string, type: SendBlacklistPostalTypeEnum): ((dispatch) => Promise<any>) => {
        return async dispatch => {
            try {
                const response = await ajax.post("/webhooks/inbound/form/driver", {
                    identifier: identifier,
                    type: type,
                });

                return Promise.resolve(response);
                // if (response?.success) {
                //     return Promise.resolve(response);
                // } else {
                //     return Promise.reject(response);
                // }
            } catch (err) {
                return Promise.reject(err);
            }
        };
    };
}

export default BlacklistAction;